// hooks/useNoIndex.ts
import { useEffect } from 'react';



export const useNoIndex = (): void => {
    useEffect(() => {        
        const noIndexDomains = ['dev.talentprise.com', 'localhost'];

        if (!noIndexDomains.includes(window.location.hostname)) {
            return;
        }

        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';

        document.head.appendChild(meta);

        return () => {
            document.head.removeChild(meta);
        };
    }, []);
};